// global window
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import Icon from '@material-ui/core/Icon';

const styles = () => ({
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
  },
  linkStyle: {
    textDecoration: 'none',
    color: '#fff',
  },
  right: {
    textDecoration: 'none',
    float: 'left',
    color: '#fff',
  },
});

const BackButton = ({ history, classes, url }) => {
  if (history.location.pathname !== '/') {
    return (
      <IconButton onClick={() => url?history.push(url) : history.goBack()}>
        <Icon className={classes.linkStyle}>arrow_back</Icon>
      </IconButton>
    );
  }
  return null;
};

BackButton.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  history: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
  url: PropTypes.string,
  /* eslint-enable */
};

export default withRouter(withStyles(styles)(BackButton));
